exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.sellersResults[data-v-e2f33d56] {\n  border: 1px solid silver;\n  border-collapse: separate;\n  border-spacing: 0;\n  border-radius: 0 0 15px 15px;\n  overflow: hidden;\n  width: 100%;\n}\n.sellersResults th[data-v-e2f33d56] {\n  background-color: black;\n  border: 1px solid silver;\n  color: white;\n  font-weight: normal;\n  height: 40px;\n}\n.sellersResults tbody tr td[data-v-e2f33d56] {\n  border-top: 1px solid silver;\n  padding-top: 5px;\n  padding-bottom: 5px;\n}\n.sellersResults tbody tr td[data-v-e2f33d56],.sellersResults thead th[data-v-e2f33d56] {\n  text-align: center;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"minimize":false,"sourceMap":false}!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-e2f33d56","scoped":true,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/pages/requests/HistoryPage.vue
// module id = 1658
// module chunks = 2